import * as React from 'react';
import Radium from 'radium';

@Radium
export default class WhatWeDo extends React.Component {
  render() {
    return (
      <p style={styles.base}>
        Studenti vysokých škol, kteří kromě svého studia, pomocí hravých a interaktivních workshopů, pomáhají žákům středních škol zamyslet se nad zdánlivě obyčejnými věcmi. Naše workshopy jsou garantované odborníky, ale pro žáky jsou zdarma. Děláme je srdcem, v celé ČR a děláme je skvěle - za přínos společnosti v oblasti kritického myšlení jsme byli i oceněni cenou Gratias Tibi.
      </p>
    );
  }
}

const styles = {
  base: {
    textAlign: 'justify',
    fontSize: 18,
    margin: 0
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/components/what_we_do/index.jsx